/** Normalize subscription_plan_features from API / localStorage. */
export function normalizePlanFeatures(features) {
  if (!features) return [];
  let raw = features;
  if (typeof raw === 'string') {
    try {
      raw = JSON.parse(raw);
    } catch {
      return [];
    }
  }
  if (!Array.isArray(raw)) return [];
  return raw
    .map((f) => (typeof f === 'string' ? f.trim().toLowerCase() : ''))
    .filter(Boolean);
}

export function normalizeAuthUser(user) {
  if (!user) return user;
  return {
    ...user,
    subscription_plan_features: normalizePlanFeatures(user.subscription_plan_features),
  };
}
